/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayForwardIcon24Regular = forwardRef('MediaUiAPlayForwardIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.95 3.967c-1.165-.752-2.7.084-2.7 1.47v13.127c0 1.386 1.535 2.222 2.7 1.47l10.157-6.564a1.75 1.75 0 0 0 0-2.94L10.95 3.967Zm-1.2 1.47a.25.25 0 0 1 .386-.21l10.157 6.563a.25.25 0 0 1 0 .42l-10.157 6.563a.25.25 0 0 1-.386-.21V5.438Z" }),
        React.createElement("path", { d: "M5.75 4.5a.75.75 0 0 0-1.5 0v15a.75.75 0 0 0 1.5 0v-15Z" })));
});
